import { Col, Divider, Row } from 'antd'
import { FieldActionsRight } from './OrderFormFooter/FieldActionsRight'
import { FieldActionsLeft } from './OrderFormFooter/FieldActionsLeft'
import { FieldUpdateActionsRight } from './OrderFormFooter/FieldUpdateActionsRight'

function OrderFormFooter({ type }: { type: 'create' | 'update' }) {
  return (
    <Row style={{ flexDirection: 'column' }}>
      <Divider />
      <Row justify="space-between" style={{ padding: '20px', order: 3 }}>
        <Col span={12} style={{ display: 'flex', gap: 10 }}>
          <FieldActionsLeft />
        </Col>
        <Col
          span={12}
          style={{ display: 'flex', gap: 10, justifyContent: 'end' }}
        >
          {type === 'create' ? (
            <FieldActionsRight />
          ) : (
            <FieldUpdateActionsRight />
          )}
        </Col>
      </Row>
    </Row>
  )
}

export default OrderFormFooter
